'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateTargetWidth = exports.positionInZoneBar = exports.getZoneIndex = exports.isInTarget = exports.isDisconnected = exports.isChromecastDeviceAvailable = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _bluetooth = require('constants/bluetooth');

var _bluetooth2 = _interopRequireDefault(_bluetooth);

var _video = require('constants/video');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var percentPerZone = 20;

var isChromecastDeviceAvailable = exports.isChromecastDeviceAvailable = function isChromecastDeviceAvailable() {
  return global.cast && global.cast.framework && global.cast.framework.CastContext.getInstance().getCastState() !== global.cast.framework.CastState.NO_DEVICES_AVAILABLE;
};

var isDisconnected = exports.isDisconnected = function isDisconnected(device) {
  return [_bluetooth2.default.DEVICE_CONNECTED, _bluetooth2.default.READY_TO_CAST, _bluetooth2.default.UNINITIALIZED, _bluetooth2.default.ADMIN].indexOf(device.status) === -1 || device.disconnected;
};

var isInTarget = exports.isInTarget = function isInTarget(percentage, targetZone) {
  return targetZone && percentage <= targetZone.max_percent && percentage >= targetZone.min_percent;
};

var getZoneIndex = exports.getZoneIndex = function getZoneIndex(percentage) {
  return percentage > 100 ? _video.ZONES.length - 1 : Math.max(_video.ZONES.findIndex(function (z) {
    return percentage > z.min && percentage <= z.max;
  }), 0);
};

var positionInZoneBar = exports.positionInZoneBar = function positionInZoneBar(percentage) {
  percentage = Math.max(Math.min(percentage, 100), 0);
  var i = Math.max(_video.ZONES.findIndex(function (z) {
    return percentage > z.min && percentage <= z.max;
  }), 0);
  var calculated = percentPerZone * i + (percentage - _video.ZONES[i].min) / (_video.ZONES[i].max - _video.ZONES[i].min) * percentPerZone;
  return Math.max(Math.min(calculated, 100), 0);
};

var calculateTargetWidth = exports.calculateTargetWidth = function calculateTargetWidth(targetZone) {
  return (typeof targetZone === 'undefined' ? 'undefined' : (0, _typeof3.default)(targetZone)) === 'object' ? Math.max(positionInZoneBar(targetZone.max_percent) - positionInZoneBar(targetZone.min_percent), 0) : 0;
};